import { fmtEUR } from "@/lib/api";

const PALETTE = {
    ready: { bar: "#0A0A0A", label: "text-[#5C5F66]", dot: "bg-[#5C5F66]" },
    info: { bar: "#002FA7", label: "text-[#002FA7]", dot: "bg-[#002FA7]" },
    success: { bar: "#34C759", label: "text-[#1F8A3E]", dot: "bg-[#34C759]" },
    warning: { bar: "#FFCC00", label: "text-[#7A5C00]", dot: "bg-[#FFCC00]" },
    error: { bar: "#FF3B30", label: "text-[#B11919]", dot: "bg-[#FF3B30]" },
};

export default function DisplayPanel({ display, clearCountdown }) {
    const c = PALETTE[display.status] || PALETTE.ready;
    const hasAmount =
        display.amount !== null &&
        display.amount !== undefined &&
        typeof display.amount.value === "number";
    const positive = hasAmount && display.amount.value > 0;
    const boxClasses = positive
        ? "border-[#34C759] bg-[#EAF7EE] text-[#1F8A3E]"
        : "border-[#FF3B30] bg-[#FDEAE8] text-[#B11919]";
    const showCountdown = typeof clearCountdown === "number" && clearCountdown > 0;

    return (
        <div
            className="shrink-0 bg-white border-b-2 border-[#0A0A0A]"
            data-testid="display-panel"
        >
            <div
                className="flex items-stretch border-l-[8px] transition-colors duration-300"
                style={{ borderLeftColor: c.bar }}
            >
                <div className="flex-1 min-w-0 px-5 md:px-8 py-3 md:py-4 flex items-center gap-4 md:gap-6">
                    <div className="min-w-0 flex-1">
                        <div
                            className={`text-[10px] md:text-xs font-bold uppercase tracking-[0.25em] ${c.label} flex items-center gap-2 mb-1`}
                        >
                            <span
                                className={`inline-block w-2 h-2 rounded-full ${c.dot}`}
                            />
                            {display.title}
                        </div>
                        <div className="font-heading text-2xl md:text-4xl font-black tracking-tighter text-[#0A0A0A] truncate leading-tight">
                            {display.primary}
                        </div>
                        {display.lines && display.lines.length > 0 && (
                            <div className="mt-1 flex flex-wrap items-center gap-x-4 gap-y-1 text-xs text-[#5C5F66] font-medium">
                                {display.lines.map((ln, i) => {
                                    const isOverride =
                                        typeof ln === "string" &&
                                        ln.includes("ΕΙΔΙΚΟ ΟΡΙΟ");
                                    if (isOverride) {
                                        return (
                                            <span
                                                key={i}
                                                data-testid="pos-month-override-badge"
                                                className="whitespace-nowrap inline-flex items-center bg-[#5856D6] text-white px-2 py-0.5 font-black tracking-wider text-[11px] uppercase"
                                            >
                                                {ln}
                                            </span>
                                        );
                                    }
                                    return (
                                        <span key={i} className="whitespace-nowrap">
                                            {i > 0 && (
                                                <span className="text-[#E2E4E9] mr-4">|</span>
                                            )}
                                            {ln}
                                        </span>
                                    );
                                })}
                            </div>
                        )}
                    </div>
                    {hasAmount && (
                        <div
                            className={`shrink-0 border-[3px] ${boxClasses} px-5 md:px-8 py-2 md:py-3 transition-colors duration-300`}
                        >
                            <div className="text-[9px] md:text-[10px] font-bold uppercase tracking-[0.25em] opacity-80">
                                {display.amount.label || "ΣΥΝΟΛΟ"}
                            </div>
                            <div className="font-heading text-3xl md:text-5xl font-black tracking-tighter leading-none mt-0.5">
                                {fmtEUR(display.amount.value)}
                            </div>
                        </div>
                    )}
                    {showCountdown && (
                        <div
                            data-testid="customer-clear-countdown"
                            className="shrink-0 border-[3px] border-[#FF3B30] bg-[#FDEAE8] text-[#B11919] flex flex-col items-center justify-center aspect-square w-[72px] md:w-[96px] animate-pulse-slow"
                            title="Αυτόματη εκκαθάριση πελάτη σε…"
                        >
                            <div className="text-[8px] md:text-[9px] font-bold uppercase tracking-[0.2em] opacity-80 leading-none">
                                ΛΗΞΗ
                            </div>
                            <div className="font-heading text-3xl md:text-5xl font-black tracking-tighter leading-none">
                                {clearCountdown}
                            </div>
                            <div className="text-[8px] md:text-[9px] font-bold uppercase tracking-[0.2em] opacity-70 leading-none">
                                SEC
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}
